import { ref, onMounted, watch } from 'vue';

export default function useMonthSelector(isEnabled, fetchData) {
    const selectedMonth = ref(null);
    const availableMonths = ref([]);

    onMounted(() => {
        if (isEnabled) {
            const today = new Date();
            for (let i = 0; i < 6; i++) {
                const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                const monthString = month < 10 ? `0${month}` : `${month}`;
                availableMonths.value.push({ label: `${year}-${monthString}`, value: `${year}-${monthString}` });
            }
            selectedMonth.value = availableMonths.value[0].value;
            watch(selectedMonth, () => {
                fetchData({ month: selectedMonth.value });
            });
        }
    });

    return { selectedMonth, availableMonths };
}
